export default class ArticleScite {
    constructor() {
        this.sciteDataCheck();
    }
    sciteDataCheck() {
        const sciteContainer = document.querySelector('.scite-badge');
        this.titleToggle();

        // Wait the scite library script to add the elements to the dom
        sciteContainer.addEventListener('DOMNodeInserted', () => {
            this.titleToggle();
        });
    }
    titleToggle() {
        const sciteTitle = document.querySelector('.scite__title');
        const hasData = document.querySelector('.Tally__show___EesAt');
        if (hasData) {
            sciteTitle.style.display = 'block';
        }
    }
}
